<div class="row page-header">
    <div class="col-12">
        <h1>
            Plans and Specs
            <small>Manage job plans and specifications</small>
        </h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <wj-combo-box
                    [(ngModel)]="selectedJob"
                    name="selectedJob"
                    (ngModelChange)="onJobChanged()"
                    style="width: 400px"
                    [itemsSource]="jobMap"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
                <button
                    type="button"
                    class="btn btn-sm btn-secondary"
                    style="margin-left: 10px"
                    (click)="fileInput.click()"
                    [disabled]="!selectedJob() || selectedJob() === ''"
                >
                    <fa-icon [icon]="faUpload"></fa-icon> Upload File(s)
                </button>
                <button
                    type="button"
                    class="btn btn-sm btn-danger"
                    style="margin-left: 10px"
                    (click)="deleteFiles()"
                    [disabled]="!selectedJob() || selectedJob() === '' || !hasSelectedFiles"
                >
                    <fa-icon [icon]="faTrash"></fa-icon> Delete Checked
                </button>
                <button
                    type="button"
                    class="btn btn-sm btn-secondary"
                    style="margin-left: 10px"
                    (click)="navigate()"
                    [disabled]="!selectedJob() || selectedJob() === ''"
                    [hidden]="!selectedJob() || selectedJob() === ''"
                >
                    <fa-icon class="d-none d-sm-inline-block" [icon]="faMap"></fa-icon> Navigate ({{ addressString }})
                </button>
                <input style="display: none" type="file" (change)="onFileChanged($event)" #fileInput multiple />
            </form>
        </div>
    </div>
    <div class="row" style="margin-top: 15px" [hidden]="!selectedJob() || selectedJob() === ''">
        <div class="col-12">
            <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()">
                @for (category of categories; track category.id) {
                    <li [ngbNavItem]="category.id">
                        <a ngbNavLink>{{ category.name }}</a>
                    </li>
                }
            </ul>
            <div class="row" style="margin-top: 15px">
                <div class="col-12">
                    <div class="alert alert-info" role="alert" [hidden]="grid.items && grid.items.length > 0">
                        <p class="mb-0">No files have been uploaded for this category yet.</p>
                    </div>
                    <wj-flex-grid
                        id="filesGrid"
                        #filesGrid
                        appAutoSize
                        (initialized)="grid.initialize(filesGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                        [hidden]="!grid.items || grid.items.length === 0"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="' '" [binding]="''" [width]="26" [isReadOnly]="true">
                            <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                <input
                                    type="checkbox"
                                    [checked]="checkedFiles.has(cell.item.fileName)"
                                    (click)="$event.stopPropagation()"
                                    (change)="toggleRowSelection(cell.item, $any($event.target).checked)"
                                />
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'File Name'" [binding]="'fileName'" [width]="'*'" [minWidth]="200">
                            <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                <a [href]="cell.item.url" class="text-decoration-none">
                                    {{ cell.item.fileName }}
                                </a>
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Size'" [binding]="'size'" [width]="120" [format]="'N0'">
                            <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                {{ cell.item.size / 1000 | number: '1.0-0' }} KB
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Last Modified'"
                            [binding]="'lastModified'"
                            [width]="180"
                            [format]="'g'"
                        >
                            <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                {{ cell.item.lastModified | date: 'short' }}
                            </ng-template>
                        </wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="margin-top: 15px" [hidden]="selectedJob() && selectedJob() !== ''">
        <div class="col-12">
            <p>Please select a project from the dropdown above.</p>
        </div>
    </div>
</div>
